import React, { useState } from 'react'
import styles from './styles.module.scss'
import { getDescryptedMedia } from 'srcReact/helpers/utils'
import { useIntersect } from 'srcReact/helpers/hooks/useIntersect'
import ProgressiveImg from 'srcReact/components/common2/ProgressiveImg'
import ImageLoader from 'srcReact/components/common2/ImageLoader'

function SingleImage({ file, index, isFilesOwner, files, showImageModal, feedId, parentElementId, feed, feedLevel }) {
  const [decryptedImage, setDecryptedImage] = useState('')
  const [ref, entry] = useIntersect(
    {
      root: parentElementId ? document.querySelector(`#${parentElementId}`) : null,
      rootMargin: '40%'
    },
    () => {
      if (file?.url) {
        const { url, is_original, original_tag, mime_type } = file
        getDescryptedMedia(url, is_original, original_tag, mime_type, file.id).then((data) => {
          setDecryptedImage(data.img)
        })
      }
    }
  )

  return (
    <div className={styles.fileContainer}>
      <button
        id={file.id}
        ref={ref}
        type='button'
        key={file.id}
        className={`${styles.imageButton} ${styles.isSquare}`}
        aria-label={file.name}
        style={
          file.path
            ? {
                backgroundImage: `url("${decryptedImage}")`
              }
            : null
        }
        onClick={() => showImageModal && showImageModal(file, index, files, isFilesOwner, feedId, feed, feedLevel)}>
        {decryptedImage ? (
          <React.Fragment>
            {' '}
            <div className={styles.overlay} />
            <ProgressiveImg src={decryptedImage} placeholderSrc={file.thumbnail_path} className={styles.image} />
          </React.Fragment>
        ) : (
          <ImageLoader showLoader={true} />
        )}
      </button>
    </div>
  )
}

export default SingleImage
